var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showLoading)?_c('div',{staticClass:"loadbox"},[_c('van-skeleton',{attrs:{"title":"","row":10}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }